export const toBoolean = (value: string | boolean): boolean => {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1' || value === 'yes';
  }
  return value;
};
